function hexToBytes(hex) {
    if (typeof hex !== 'string' || hex.length % 2 !== 0) return null;
    if (!/^[0-9a-f]+$/i.test(hex)) return null;
    const out = new Uint8Array(hex.length / 2);
    for (let i = 0; i < out.length; i += 1) {
        out[i] = parseInt(hex.substr(i * 2, 2), 16);
    }
    return out;
}

function bytesToHex(bytes) {
    const arr = new Uint8Array(bytes);
    let hex = '';
    for (let i = 0; i < arr.length; i += 1) {
        hex += arr[i].toString(16).padStart(2, '0');
    }
    return hex;
}

export async function sha256Hex(input) {
    const data = typeof input === 'string' ? new TextEncoder().encode(input) : input;
    const digest = await crypto.subtle.digest('SHA-256', data);
    return bytesToHex(digest);
}

export function generateSeedHex() {
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    return bytesToHex(bytes);
}

export async function commitFromSeed(seedHex) {
    const bytes = hexToBytes(seedHex);
    if (!bytes || bytes.length !== 32) throw new Error('invalid seed');
    return sha256Hex(bytes);
}

export async function verifyCommit(seedHex, commitHex) {
    if (typeof seedHex !== 'string' || typeof commitHex !== 'string') return false;
    if (seedHex.length !== 64 || commitHex.length !== 64) return false;
    try {
        const computed = await commitFromSeed(seedHex);
        return computed.toLowerCase() === commitHex.toLowerCase();
    } catch {
        return false;
    }
}

export async function computeCoinResult(serverSeedHex, playerASeedHex, playerBSeedHex) {
    const combined = `${serverSeedHex}${playerASeedHex}${playerBSeedHex}`;
    const hash = await sha256Hex(combined);
    return parseInt(hash.substring(0, 8), 16) % 2;
}
